import script from "./file-list-item.vue?vue&type=script&setup=true&lang=ts"
export * from "./file-list-item.vue?vue&type=script&setup=true&lang=ts"

import "./file-list-item.vue?vue&type=style&index=0&id=77d53ad8&lang=scss"

const __exports__ = script;

export default __exports__